import * as yup from 'yup';

const schema = yup.object().shape({
  otp_code: yup.number().required('OTP field is required'),
});

export default schema;
